<template>
  <div class="customerDetail">
    <div class="fixed-box">
      <div class="back-bar">
        <feather-icon
          class="pointer"
          @click="goBack"
          icon="ChevronLeftIcon"
        ></feather-icon>
        <span class="small-title">客户详情</span>
      </div>
      <div class="done-box" >
        <div class="done-top">
          <div class="top-left">
            <div class="avavtar-box">{{getFirstLetter()}}</div>
            <div class="top-left-right">
              <span class="sitename">{{details.custName}}</span>
              <div class="email">{{details.phone}}</div>
            </div>
          </div>
          <div class="top-right">
            <vs-button
              v-if="details.auditStatus == 1"
              type="filled"
              color="primary"
              @click="updateStatus"
            >客户审核</vs-button>
          </div>
        </div>
        <div class="border-title">
        <span
          class="tag-title"
          :class="{on: tagName == 'info'}"
          @click="tagHandle('info')"
        >个人资料</span>
          <span
            class="tag-title"
            :class="{on: tagName == 'log'}"
            @click="tagHandle('log')"
          >审核记录</span>
        </div>
      </div>
    </div>
    <div class="page-content border-r-6">
      <user-info
        v-if="tagName == 'info'"
        :user-info="details"
      ></user-info>
      <audit-log
        v-if="tagName == 'log'"
        :cust-events="details.custEvents"
      ></audit-log>
    </div>
    <audit-dialog
      :active="active"
      @close="close"
      @send-form="sureHandle"
    ></audit-dialog>
  </div>
</template>

<script>
  import auditDialog from '@/components/walletManage/auditDialog'
  import { queryCustDetail,auditCust } from '@/api/wallet'
  import userInfo from '@/components/walletManage/customerDetail/userInfo'
  import auditLog from '@/components/walletManage/customerDetail/auditLog'
    export default {
      name: "customerDetail",
      components:{
        userInfo,
        auditLog,
        auditDialog,
      },
      data() {
        return {
          tagName: 'info',
          details:{
            custName: '',
            custEvents: []
          },
          active: false,
        }
      },
      mounted(){
        this.getDetail();
      },
      methods: {
        goBack(){
          this.$store.commit('setBeforePage', this.$route.query.page);
          this.$router.go(-1);
        },
        getFirstLetter(){
          if(this.details.custName){
            return this.details.custName.toUpperCase().charAt(0);
          }else {
            return ''
          }
        },
        close(){
          this.active = false;
        },
        doneSuccess(){
          this.getDetail();
        },
        getDetail(){
          queryCustDetail({
            id: this.$route.params.id,
          }).then((res) => {
            console.log(res);
            this.details = res.data;
          })
        },
        tagHandle(tagName) {
          this.tagName = tagName;
        },
        updateStatus(){
          //
          this.active = true;
        },
        sureHandle(params){
          let paramsData = {
            ...params,
            custId: this.$route.params.id,
          }
          auditCust(paramsData).then((res) => {
            this.getDetail();
            this.$vs.notify({
              text:'操作成功',
              position: 'top-right'
            })
          })
        }
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variable";
.customerDetail {
  .fixed-box {
    background-color: #ffffff;
    width: 100%;
    margin-bottom: 1.7rem;
    .back-bar {
      height: 5rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 1rem;
      border-bottom: 1px solid #EBE9F1;
      .small-title {
        margin-left: 10px;
        font-size: 20px;
        font-weight: bold;
      }
    }
    .done-box {
      .done-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 1rem;
        padding-bottom: 0;
        .top-left {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .avatar {
            width: 60px;
            height: 60px;
            margin-right: 20px;
          }
          .sitename {
            color: #5E5873;
            font-size: 18px;
            font-weight: bold;
          }
          .email {
            margin-top: 10px;
          }
          .status {
            margin-left: 10px;
          }
        }
      }
      .border-title {
        line-height: 3.2rem;
        padding-left: 7rem;
        .tag-title {
          display: inline-block;
          margin-right: 30px;
          cursor: pointer;
          &.on {
            color: $themeColor;
            border-bottom: 2px solid $themeColor;
          }
        }
      }
    }
    .avavtar-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 60px;
      border-radius: 5px;
      margin-right: 24px;
      background-color: $themeColor;
      color: #ffffff;
      font-size: 24px
    }
  }
  .page-content {

  }
}
</style>
